export default "__VITE_ASSET__CORnMcYJ__"